import { Injectable } from "@angular/core";
import { Configuration } from "app/models/configuration.model";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";

const CONFIGURATION_KEY = "StationConfiguration";
const ConfigurationPassword = "ConfigurationPassword";
@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  public default_configuration: Configuration = {
    stationName: "",
    urlApi: environment.apiUrl,
    urlWebSocketCloud: environment.webSocketURL,
    defaultMachines: [],
    maxDifInfoComp: 10,
    inputKgUnitLot: false,
    boxCode: false,
    stopScreen: false,
    divideContainer: false,
    hideCadence: false,
    hideProductionDetail: false,
    showJustifyNOKButton: false,
    masterSlaveMode: false,
    roundToNearestHalf: false,
    showOfChangeButton: false,
    disableOkNokQuantities: false,
    generalProductionButtonsTimeout: undefined,
    productionButtonsVisible: false,
    productionButtonText1: "1",
    productionButtonTimeout1: 1,
    printerLabelTemplate1: "", //`{"DB":"DB2","DATA":"D1","DATATYPE":15,"VALUE":"{VALUE}"};{"DB":"SATO.WRITE","DATA":"SEND","DATATYPE":11,"VALUE":"\u001bA\u001bPS\u001b%2\u001bH1100\u001bV00401\u001bBG03168>H{SN}\u001b%2\u001bH1100\u001bV00231\u001bP02\u001bRDB@0,029,029,{SN}\u001bQ1\u001bZ"}`,
    productionButtonText2: "2",
    productionButtonTimeout2: 2,
    printerLabelTemplate2: "", //`{"DB":"DB2","DATA":"D1","DATATYPE":15,"VALUE":"{VALUE}"};{"DB":"SATO.WRITE","DATA":"SEND","DATATYPE":11,"VALUE":"\u001bA\u001bPS\u001b%2\u001bH1100\u001bV00401\u001bBG03168>H{SN}\u001b%2\u001bH1100\u001bV00231\u001bP02\u001bRDB@0,029,029,{SN}\u001bQ1\u001bZ"}`,
    productionButtonText3: "3",
    productionButtonTimeout3: 3,
    printerLabelTemplate3: "", //`{"DB":"DB2","DATA":"D1","DATATYPE":15,"VALUE":"{VALUE}"};{"DB":"SATO.WRITE","DATA":"SEND","DATATYPE":11,"VALUE":"\u001bA\u001bPS\u001b%2\u001bH1100\u001bV00401\u001bBG03168>H{SN}\u001b%2\u001bH1100\u001bV00231\u001bP02\u001bRDB@0,029,029,{SN}\u001bQ1\u001bZ"}`,
    productionStartDbCommands: "",
    printContainerTemplate: "",
    clientId: "",
    clientSecret: "",
  };
  public default_StationName = "";
  public default_ConfigurationPassword = "1234";
  public masterSlaveObservable: Observable<boolean>;
  public masterSlaveSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  public get currentConfiguration(): Configuration {
    let config = localStorage.getItem(CONFIGURATION_KEY);
    return config ? JSON.parse(config) : this.default_configuration;
  }

  constructor() {
    this.masterSlaveObservable = this.masterSlaveSubject.asObservable();
    this.masterSlaveSubject.next(this.getMasterSlaveMode());
  }

  // gets
  get_StationName(): string {
    return this.currentConfiguration.stationName;
  }
  get_URL_API(): string {
    return this.currentConfiguration.urlApi;
  }
  get_URL_WebSocketCloud(): string {
    return this.currentConfiguration.urlWebSocketCloud;
  }
  get_ConfigurationPassword(): string {
    return (
      localStorage.getItem(ConfigurationPassword) ??
      this.default_ConfigurationPassword
    );
  }
  getDefaultMachines(): string[] {
    return this.currentConfiguration.defaultMachines;
  }
  getMaxDifInfoComp(): number {
    return this.currentConfiguration.maxDifInfoComp;
  }
  getInputKgUnitLot(): boolean {
    return this.currentConfiguration.inputKgUnitLot;
  }
  getBoxCode(): boolean {
    return this.currentConfiguration.boxCode;
  }
  getStopScreen(): boolean {
    return this.currentConfiguration.stopScreen;
  }
  getDivideContainer(): boolean {
    return this.currentConfiguration.divideContainer;
  }
  getHideCadence(): boolean {
    return this.currentConfiguration.hideCadence;
  }
  getHideProductionDetail(): boolean {
    return this.currentConfiguration.hideProductionDetail;
  }
  getShowJustifyNOKButton(): boolean {
    return this.currentConfiguration.showJustifyNOKButton;
  }
   getdisableOkNokQuantities(): boolean {
    return this.currentConfiguration.disableOkNokQuantities;
  }
  getGeneralProductionButtonsTimeout(): number | undefined {
    return this.currentConfiguration.generalProductionButtonsTimeout;
  }
  getProductionButtonsVisible(): boolean {
    return this.currentConfiguration.productionButtonsVisible;
  }
  getProductionButtonText_1(): string {
    return this.currentConfiguration.productionButtonText1;
  }
  getProductionButtonTimeout_1(): number {
    return this.currentConfiguration.productionButtonTimeout1;
  }
  getPrinterLabelTemplate_1(): string {
    return this.currentConfiguration.printerLabelTemplate1.replace(
      /[\u0000-\u001F]/g,
      (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
    );
  }
  getProductionButtonText_2(): string {
    return this.currentConfiguration.productionButtonText2;
  }
  getProductionButtonTimeout_2(): number {
    return this.currentConfiguration.productionButtonTimeout2;
  }
  getPrinterLabelTemplate_2(): string {
    return this.currentConfiguration.printerLabelTemplate2.replace(
      /[\u0000-\u001F]/g,
      (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
    );
  }
  getProductionButtonText_3(): string {
    return this.currentConfiguration.productionButtonText3;
  }
  getProductionButtonTimeout_3(): number {
    return this.currentConfiguration.productionButtonTimeout3;
  }
  getPrinterLabelTemplate_3(): string {
    return this.currentConfiguration.printerLabelTemplate3.replace(
      /[\u0000-\u001F]/g,
      (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
    );
  }

  getPrintContainerTemplate(containerCommands?: string): string {
    const template = containerCommands
      ? containerCommands
      : this.currentConfiguration.printContainerTemplate;
    return template.replace(
      /[\u0000-\u001F]/g,
      (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
    );
  }

  getProductionStartDbCommands(): string {
    return this.currentConfiguration.productionStartDbCommands.replace(
      /[\u0000-\u001F]/g,
      (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
    );
  }
  getMasterSlaveMode(): boolean {
    return this.currentConfiguration.masterSlaveMode;
  }

  getRoundToNearestHalf(): boolean {
    return this.currentConfiguration.roundToNearestHalf;
  }

  getShowOfChangeButton(): boolean {
    return this.currentConfiguration.showOfChangeButton;
  }

  getClientId(): string {
    return this.currentConfiguration.clientId;
  }

  getClientSecret(): string {
    return this.currentConfiguration.clientSecret;
  }

  setConfig(key: string, value: any) {
    const config = this.currentConfiguration;
    config[key] = value;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    this.getConfiguration();
  }

  setAllConfig(config: Configuration) {
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }

  // sets
  set_StationName(item: string): void {
    const config = this.currentConfiguration;
    config.stationName = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  set_URL_API(item: string): void {
    const config = this.currentConfiguration;
    config.urlApi = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  set_URL_WebSocketCloud(item: string): void {
    const config = this.currentConfiguration;
    config.urlWebSocketCloud = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  set_ConfigurationPassword(item: string): void {
    localStorage.setItem(ConfigurationPassword, item);
    //Read to persist data
    this.getConfiguration();
  }
  setDefaultMachines(item: string[]) {
    const config = this.currentConfiguration;
    config.defaultMachines = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setMaxDifInfoComp(item: number): void {
    const config = this.currentConfiguration;
    config.maxDifInfoComp = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setInputKgUnitLot(item: boolean): void {
    const config = this.currentConfiguration;
    config.inputKgUnitLot = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setBoxCode(item: boolean): void {
    const config = this.currentConfiguration;
    config.boxCode = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setStopScreen(item: boolean): void {
    const config = this.currentConfiguration;
    config.stopScreen = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setDivideContainer(item: boolean): void {
    const config = this.currentConfiguration;
    config.divideContainer = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setHideCadence(item: boolean): void {
    const config = this.currentConfiguration;
    config.hideCadence = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setHideProductionDetail(item: boolean): void {
    const config = this.currentConfiguration;
    config.hideProductionDetail = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setGeneralProductionButtonsTimeout(item: number | undefined): void {
    const config = this.currentConfiguration;
    config.generalProductionButtonsTimeout = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setProductionButtonText_1(item: string): void {
    const config = this.currentConfiguration;
    config.productionButtonText1 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setProductionButtonTimeout_1(item: number): void {
    const config = this.currentConfiguration;
    config.productionButtonTimeout1 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setPrinterLabelTemplate_1(item: string): void {
    const config = this.currentConfiguration;
    config.printerLabelTemplate1 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setProductionButtonText_2(item: string): void {
    const config = this.currentConfiguration;
    config.productionButtonText2 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setProductionButtonTimeout_2(item: number): void {
    const config = this.currentConfiguration;
    config.productionButtonTimeout2 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setPrinterLabelTemplate_2(item: string): void {
    const config = this.currentConfiguration;
    config.printerLabelTemplate2 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setProductionButtonText_3(item: string): void {
    const config = this.currentConfiguration;
    config.productionButtonText3 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setProductionButtonTimeout_3(item: number): void {
    const config = this.currentConfiguration;
    config.productionButtonTimeout3 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setPrinterLabelTemplate_3(item: string): void {
    const config = this.currentConfiguration;
    config.printerLabelTemplate3 = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }

  setPrintContainerTemplate(item: string): void {
    const config = this.currentConfiguration;
    config.printContainerTemplate = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }

  setProductionStartDbCommands(item: string): void {
    const config = this.currentConfiguration;
    config.productionStartDbCommands = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setMasterSlavemode(item: boolean): void {
    const config = this.currentConfiguration;
    config.masterSlaveMode = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
    this.masterSlaveSubject.next(item);
  }

  setRoundToNearestHalf(item: boolean): void {
    const config = this.currentConfiguration;
    config.roundToNearestHalf = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    this.getConfiguration();
  }

  setShowOfChangeButton(item: boolean): void {
    const config = this.currentConfiguration;
    config.showOfChangeButton = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    this.getConfiguration();
  }

  setClientId(item: string): void {
    const config = this.currentConfiguration;
    config.clientId = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }
  setClientSecret(item: string): void {
    const config = this.currentConfiguration;
    config.clientSecret = item;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(config));
    //Read to persist data
    this.getConfiguration();
  }

  getConfiguration(): Configuration {
    return this.currentConfiguration;
  }
  setConfiguration(configuration: Configuration) {
    //Conservem el nom
    const oldName = this.currentConfiguration.stationName;
    localStorage.setItem(CONFIGURATION_KEY, JSON.stringify(configuration));
    this.set_StationName(oldName);
    this.getConfiguration();
  }
}
